
import { Component, Vue, Watch } from 'vue-property-decorator'
import { monthlyIncome, genderRDL, job, religion, education, married, title } from '@/utils/dictionary'
import http from '@/utils/request'
import '../register.scss'
import dayjs from 'dayjs'
import Loading from '../Loading.vue'
import StepsIndividual from '../StepsIndividual.vue'
import { sleep } from '@/utils'
import { getUserInfo } from '@/utils/user'

@Component({
  components: { StepsIndividual, Loading }
})
export default class extends Vue {
  private addressRtRwPerum = ''
  private form = {
    // info 1
    sex: '',
    birthDate: '',
    birthPlace: '',
    education: '',
    /* firstName: '', */
    /* middleName: '', */
    /* lastName: '', */
    motherMaidenName: '',
    religion: '',
    title: '',

    // info 2
    idExpiryDate: '31122099',
    idIssuingCity: '',
    /* idNumber: '', */
    npwpNum: '',

    // info 3
    married: '',
    jobCode: '',
    monthlyIncome: '',
    addressStreet: '',
    addressKel: '',
    addressKec: '',
    postcode: ''
    /* email: '' */
  }

  monthlyIncomeOptions = monthlyIncome
  jobOptions = job
  religionOptions = religion
  educationOptions = education
  marriedOptions = married
  titleOptions = title
  genderOptions = genderRDL

  submitLoading = false
  submitDisabled = true

  private showLoading = false
  private loadingStatus = ''

  @Watch('form', { deep: true })
  onFormChange() {
    // eslint-disable-next-line
    const { ...params } = this.form
    const valid = Object.values(params).every((value) => {
      return value !== '' && value !== null && value !== undefined
    })
    this.submitDisabled = !valid
  }

  testForm() {
    this.form.sex = '0'
    this.form.birthDate = dayjs().format('YYYY-MM-DD')
    this.form.birthPlace = 'London'
    this.form.education = '01'
    /* this.form.firstName = 'Mercedes ' */
    /* this.form.middleName = '&' */
    /* this.form.lastName = 'Benz' */
    this.form.motherMaidenName = 'MERG'
    this.form.religion = '1'
    this.form.title = '01'

    //

    /* this.form.idExpiryDate = dayjs().format('DDMMYYYY') */
    this.form.idIssuingCity = 'Good'
    /* this.form.idNumber = '91010101010' */
    this.form.npwpNum = '22221111'

    //
    this.form.married = 'L'
    this.form.jobCode = '01'
    this.form.monthlyIncome = '2000000'
    this.form.addressStreet = 'Kelo'
    this.form.addressKel = 'Virl'
    this.form.addressKec = 'Week'
    this.form.postcode = '000000'

    this.addressRtRwPerum = 'Footer'
  }

  mounted() {
    if (process.env.NODE_ENV === 'development') {
      this.testForm()
    }
  }

  register(): Promise<boolean> {
    const params1 = {
      sex: this.form.sex,
      birthDate: dayjs(this.form.birthDate).format('YYYY-MM-DD'),
      birthPlace: this.form.birthPlace,
      education: this.form.education,
      /* firstName: this.form.firstName, */
      /* lastName: this.form.lastName, */
      /* middleName: this.form.middleName, */
      motherMaidenName: this.form.motherMaidenName,
      religion: this.form.religion,
      title: this.form.title
    }

    const params2 = {
      idExpiryDate: this.form.idExpiryDate,
      idIssuingCity: this.form.idIssuingCity,
      /* idNumber: this.form.idNumber, */
      npwpNum: this.form.npwpNum.replace(/[^0-9]/g, '')
    }

    const params3 = {
      addressKec: this.form.addressKec,
      addressKel: this.form.addressKel,
      addressStreet: this.form.addressStreet,
      jobCode: this.form.jobCode,
      married: this.form.married,
      monthlyIncome: this.form.monthlyIncome,
      postcode: this.form.postcode
      /* email: this.form.email */
    }

    const params4 = {
      addressRtRwPerum: '',
      mid: getUserInfo('userInfoMap').mid
    }

    if (!this.addressRtRwPerum) {
      params4.addressRtRwPerum = this.form.addressStreet
    }

    return http.post('/rdl/register', { ...params1, ...params2, ...params3, ...params4 })
  }

  async submit() {
    try {
      this.submitLoading = true
      this.showLoading = true
      await sleep(1500)
      const accountStatus = await this.register()
      if (accountStatus) {
        this.$router.push('/dashboard')
      }
    } catch (error) {
    } finally {
      this.submitLoading = false
      this.showLoading = false
    }
  }
}
